import { useContext } from 'react'

import { BusinessContactsFormContext } from './business-contacts-context'

export function useBusinessContactsForm() {
  const ctx = useContext(BusinessContactsFormContext)
  if (!ctx) {
    throw new Error(
      'useBusinessContactsForm must be used within BusinessContactsFormProvider'
    )
  }
  return ctx
}
